export default "__VITE_ASSET__23520a49__"